import React from 'react';
import { array, bool, func, object } from 'prop-types';

import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TableSortLabel from '@material-ui/core/TableSortLabel';
import Tooltip from '@material-ui/core/Tooltip';
import { withStyles } from '@material-ui/core/styles';

import AgentStatus from '../../components/AgentStatus';
import BasAgentsTableRowMenu from './BasAgentsTableRowMenu';
import DriverProperty from '../../components/DriverProperty';

import classes from './BasAgentsTable.module.css';

const StyledTableRow = withStyles((theme) => ({
    root: {
        '&:nth-of-type(even)': {
            backgroundColor: '#f4f4f4',
        }
    }
}))(TableRow);

const BasAgentsTable = ({
    agents,
    companyInfo,
    isFullHubAllowed,
    onSort,
    order,
    orderBy,
    searchFilter,
    ...props
}) => {
    const isSortedByName = orderBy === 'name';
    const sortDirection = isSortedByName ? order : false;
    return (
        <div className={classes.tableWrapper}>
            <Table className={classes.table}>
                <TableHead>
                    <TableRow>
                        <TableCell className={classes.componentCell} />
                        <TableCell
                            className={classes.headerCell}
                            sortDirection={sortDirection}
                            onClick={onSort('name')}
                        >
                            <Tooltip
                                title={
                                    <span className={classes.tooltip}>
                                        Sort
                                    </span>
                                }
                                placement="top-start"
                            >
                                <TableSortLabel
                                    active={isSortedByName}
                                    direction={order}
                                >
                                    Name
                                </TableSortLabel>
                            </Tooltip>
                        </TableCell>
                        <TableCell className={classes.headerCell}>
                            Bas Drivers
                        </TableCell>
                        <TableCell className={classes.headerCell}>
                            Serial Number
                        </TableCell>
                        <TableCell className={classes.headerCell}>
                            Firmware
                        </TableCell>
                        <TableCell className={classes.headerCell}>
                            Bas Load
                        </TableCell>
                        <TableCell className={classes.componentCell} />
                    </TableRow>
                </TableHead>
                <TableBody>
                    {agents.filter(a => a.name.toLowerCase().includes(searchFilter.toLowerCase())).map(agent =>
                        <StyledTableRow key={agent.id}>
                            <TableCell
                                className={classes.dataCell}
                                padding="none"
                            >
                                <AgentStatus agent={agent} />
                            </TableCell>
                            <TableCell className={`${classes.dataCell} ${classes.ellipseCell}`}>
                                <Tooltip
                                    title={
                                        <span className={classes.tooltip}>
                                            {agent.name}
                                        </span>
                                    }
                                    placement="top-start"
                                >
                                    <span>{agent.name}</span>
                                </Tooltip>
                            </TableCell>
                            <TableCell className={classes.dataCell}>
                                <DriverProperty
                                    config={agent.driverConfiguration}
                                    property="basType"
                                />
                            </TableCell>
                            <TableCell className={`${classes.dataCell} ${classes.ellipseCell}`}>
                                <Tooltip
                                    title={
                                        <span className={classes.tooltip}>
                                            {agent.serialNumber || 'No Agent Assigned'}
                                        </span>
                                    }
                                    placement="top-start"
                                >
                                    <span>
                                        {agent.serialNumber || 'No Agent Assigned'}
                                    </span>
                                </Tooltip>
                            </TableCell>
                            <TableCell className={classes.dataCell}>
                                {agent.firmwareVersion}
                            </TableCell>
                            <TableCell className={classes.dataCell}>
                                <DriverProperty
                                    config={agent.driverConfiguration}
                                    format="percent"
                                    property="currentLoad"
                                />
                            </TableCell>
                            <TableCell
                                className={classes.rowMenuCell}
                                padding="none"
                            >
                                <BasAgentsTableRowMenu
                                    agent={agent}
                                    companyInfo={companyInfo}
                                    hidden={!isFullHubAllowed}
                                    onAssignAgentModal={props.onAssignAgentModal}
                                    onDeleteModal={props.onDeleteModal}
                                    onHandleSiteLinking={props.onHandleSiteLinking}
                                    onRenameAgentModal={props.onRenameAgentModal}
                                    onResetConfirmationModal={props.onResetConfirmationModal}
                                    onStopInventoryScan={props.onStopInventoryScan}
                                    onUnAssignAgentModal={props.onUnAssignAgentModal}
                                />
                            </TableCell>
                        </StyledTableRow>
                    )}
                </TableBody>
            </Table>
        </div>
    );
};

BasAgentsTable.defaultProps = {
    isFullHubAllowed: true,
    onSort:           () => {}
};

BasAgentsTable.propTypes = {
    agents:                   array.isRequired,
    companyInfo:              object,
    isFullHubAllowed:         bool,
    onAssignAgentModal:       func,
    onDeleteModal:            func,
    onRenameAgentModal:       func,
    onResetConfirmationModal: func,
    onStopInventoryScan:      func,
    onUnAssignAgentModal:     func,
    onSort:                   func
};

export default BasAgentsTable;
